import Component from '@bythepixel/component-loader';

export default class NotificationBanner extends Component {
  static selector = '[data-comp-notification-banner]';

  constructor(...args) {
    super(...args);
    this.closeButton = this.$container.querySelector('[data-banner-close]');
    this.messageContainer = this.$container.querySelector(
      '[data-comp-notification-banner-message]',
    );

    this.mount();
  }

  attachListeners() {
    window.addEventListener('notify', (e) => {
      const message = e.detail;

      this.notify(message);
    });

    window.addEventListener('close-notification-banner', () => {
      this.close();
    });

    this.closeButton.addEventListener('click', () => {
      this.close();
    });
  }

  close() {
    this.$container.ariaHidden = 'true';
  }

  notify(message = '') {
    this.$container.ariaHidden = 'false';
    this.messageContainer.textContent = message;
  }

  mount() {
    this.attachListeners();
  }
}
